import { useState, useEffect } from 'react';
import { basePort, getUsernameJwt, headers, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies, IsMbrRolePv } from "../../module_auth/AuthService"
import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../../component/common/Toast"
import { SelectCityList } from '../common/SelectList';

export function PersonRegPremiumMypage() {
    const [objTitle, setObjTitle] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    const [email, setEmail] = useState("");
    const [workCity, setWorkCity] = useState("");
    const [workTime, setWorkTime] = useState("");
    const [visaStat, setVisaStat] = useState("");
    const [eduHist, setEduHist] = useState('');
    const [resumeHist, setResumeHist] = useState('');
    const [pvIntro, setPvIntro] = useState('');
    const [mbrId, setMbrId] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("/");

    const [cityList, setCityList] = useState([]);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            setRedirectUrl("/login")
            setRedirect(true)
        } else if(!IsMbrRolePv(getJwtFromCookies())) {
            setRedirectUrl("/")
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            getPvData()
            getCityList()
        }
    }, []);

    function getPvData(){
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/get/pv/mypage', 
            {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                //setMemberEntity(response)
                setFullname(response.fullname)
                setTelno(response.telno)
                setEmail(response.email)
                setWorkCity(response.workCity)
                setWorkTime(response.workTime)
                setVisaStat(response.visaStat)
                setEduHist(response.eduHist)
                setResumeHist(response.resumeHist)
                setPvIntro(response.pvIntro)
        }).catch(error => console.log(error))
    }

    function getCityList(){
        let url = basePort + '/get/config'
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
               setCityList(response.cityEntityList)
          }).catch(error => console.log(error))
    }

    function handleObjTitle(event) {
        setObjTitle(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handleTelno(event) {
        setTelno(event.target.value);
    }

    function handleEmail(event) {
        setEmail(event.target.value);
    }

    function handleWorkCity(event) {
        setWorkCity(event.target.value);
    }

    function handleWorkTime(event) {
        setWorkTime(event.target.value);
    }

    function handleVisaStat(event) {
        setVisaStat(event.target.value);
    }

    function clickSubmit(event) {
        event.preventDefault();
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/post/person', 
            {method:'post', headers,
                      body:JSON.stringify({
                        objTitle:objTitle,
                        mbrId: mbrId,
                        telno:telno,
                        workCity:workCity,
                        workTime:workTime,
                        visaStat:visaStat,
                        eduHist:eduHist,
                        resumeHist:resumeHist,
                        pvIntro:pvIntro,
                        //프리미엄등록 1, 일반등록 0
                        regType:"1",
                        //즉시 포스팅 validObj:1, 관리자승인필요 validObj:0
                        validObj:"0"
                    })})
                    .then(response => response.json())
                    .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            setTimeout(function() {
                                moveTo()
                            }.bind(this), 3000)
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    let navigate = useNavigate();
    function moveTo() {
        let url = "/person_list_mypage"
        navigate(url);
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function handleImage(){
    }

    return (
        <div>
            {renderRedirect(redirect, redirectUrl)}
            <main class="page lanidng-page">
            <section>
            <div class="container"  style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a><span>인재정보</span></a></li>
                    <li class="breadcrumb-item"><a><span>프리미엄 인재등록</span></a></li>
                </ol>
                <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                    <input class="form-control" type="text" onChange={handleObjTitle}/>
                </form>
                <p style={{fontWeight: 'bold', marginTop: '10px'}}>인재정보</p>
                <ul class="list-group">
                    <li class="list-group-item">
                        <form><label class="form-label">이름:</label><input class="form-control" type="text" value={fullname} disabled/></form>
                        <form style={{marginTop: '10px'}}><label class="form-label">이메일:</label><input class="form-control" type="text" value={email} disabled/></form>
                        <form style={{marginTop: '10px'}}><label class="form-label">연락처:</label><input class="form-control" type="text" value={telno} onChange={handleTelno} /></form>
                        <form style={{marginTop: '10px'}}><label class="form-label">근무도시:</label>
                            <SelectCityList optionValue={workCity} cityList={cityList} handleWorkCity={handleWorkCity}/>
                        </form>
                        <form style={{marginTop: '10px'}}><label class="form-label">근무형태:</label><select class="form-select" value={workTime} onChange={handleWorkTime}>
                                <option value="0" selected>선택</option>
                                <option value="1">풀타임</option>
                                <option value="2">파트타임</option>
                                <option value="3">미니잡</option>
                            </select></form>
                        <form style={{marginTop: '10px'}}><label class="form-label">비자상태:</label>
                            <select class="form-select" value={visaStat} onChange={handleVisaStat}>
                                <option value="0" selected>선택</option>
                                <option value="1">유학생비자</option>
                                <option value="2">워킹홀레데이비자</option>
                                <option value="3">취업준비비자</option>
                                <option value="4">워킹비자</option>
                            </select>
                        </form>
                        <form style={{margin: '10px', marginRight: '0', marginLeft: '0'}}>
                            <label class="form-label">학력사항:</label>
                            <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                                    <ReactQuill theme="snow" value={eduHist} onChange={setEduHist}
                                        style={{height: '300px', marginBottom:'10px'}}
                                        modules={{
                                            toolbar: {
                                                container: [
                                                    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                    [{ size: [] }],
                                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                    ['image'],
                                                    ['clean'],
                                                    ['code-block']
                                                ],
                                                handlers: {
                                                    image: handleImage(),
                                                },
                                            },
                                            
                                        }}
                                    />
                            </div>
                        </form>
                        <form style={{margin: '10px', marginRight: '0', marginLeft: '0'}}>
                            <label class="form-label">경력사항:</label>
                            <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                                    <ReactQuill theme="snow" value={resumeHist} onChange={setResumeHist}
                                        style={{height: '300px', marginBottom:'10px'}}
                                        modules={{
                                            toolbar: {
                                                container: [
                                                    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                    [{ size: [] }],
                                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                    ['image'],
                                                    ['clean'],
                                                    ['code-block']
                                                ],
                                                handlers: {
                                                    image: handleImage(),
                                                },
                                            },
                                            
                                        }}
                                    />
                            </div>
                        </form>
                        <form style={{margin: '10px', marginRight: '0', marginLeft: '0'}}>
                            <label class="form-label">자기소개:</label>
                            {/* <textarea class="form-control" style={{height: '200px'}}></textarea> */}
                            <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                                    <ReactQuill theme="snow" value={pvIntro} onChange={setPvIntro}
                                        style={{height: '300px', marginBottom:'10px'}}
                                        modules={{
                                            toolbar: {
                                                container: [
                                                    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                    [{ size: [] }],
                                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                    ['image'],
                                                    ['clean'],
                                                    ['code-block']
                                                ],
                                                handlers: {
                                                    image: handleImage(),
                                                },
                                            },
                                            
                                        }}
                                    />
                            </div>
                        </form>
                    </li>
                </ul>
                <form style={{textAlign: 'center', marginBottom: '10px', marginTop: '10px'}}><button class="btn btn-primary" type="button" onClick={clickSubmit}>등록하기</button></form>
                <ToastMessage show={showToast} msg={msgToast} />
            </div>
        </section>
            </main>
        </div>
    );
}